module.exports = __webpack_public_path__ + "static/media/result_bdl24.5f8fd5bf.jpg";